<template>
	<div class="">
		<Breadcrumb/>
		<div class="wrap">
			<Title :title="vacationName"></Title>
			<el-table size="mini" border :data="hotSchoolList" style="width: 100%">
				<el-table-column type="index">
				</el-table-column>
				<el-table-column prop="school" label="学校">
				</el-table-column>
				<el-table-column prop="number" label="人数" width="130">
				</el-table-column>
				<el-table-column label="查看">
					<template slot-scope="scope">
						<span class="text-link" @click="showSchoolDialog(scope.row)">该校学生热力榜</span>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		</div>
		<!--该校学生热力榜弹窗-->
		<el-dialog :title="school" :visible.sync="dialogTable" width="60%" @close="closeDialog">
			<el-table :data="tableData" size="mini" border style="width: 100%">
				<el-table-column prop="userName" label="姓名">
				</el-table-column>
				<el-table-column prop="number" label="分数">
				</el-table-column>
				<el-table-column prop="voteTime" label="收藏">
					<template slot-scope="scope">
						<img v-if="scope.row.isLike==1" @click.stop="cancelCollectStu(scope.row.id)" class="collect-icon" src="../../../assets/collect_icon_02.png"/>
						<img v-else @click.stop="addCollectStu(scope.row.id)" class="collect-icon" src="../../../assets/collect_icon_01.png"/>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="studentTotal" :pageSize="pageSize" @pageChange="handleCurrentChange2"/>
		</el-dialog>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import Breadcrumb from '@/components/admin/breadcrumb'
	import Pagination from '@/components/admin/pagination'
	export default {
		name: 'SchoolHot',
		components: {
			Title,
			Breadcrumb,
			Pagination
		},
		data(){
			return {
				hotSchoolList: [],
				pageNum: 1,
				pageSize: 10,
				vacationId: '',
				total: 0,
				dialogTable: false,
				enrollModel: {},
				tableData: [],
				studentTotal: 0,
				pageNum2: 1,
				pageSize2: 10,
				schoolId: '',
				school: '',
				vacationName: '高校热力榜--'
			}
		},
		created(){
			if(this.$route.query.id){
				this.vacationId = this.$route.query.id
			}
			this.getHotSchoolList()
			this.getDetailData()
		},
		methods: {
			closeDialog(){
				this.dialogTable = false
				this.pageNum2 = 1
				this.tableData = []
				this.studentTotal = 0
				this.schoolId = ''
				this.school = ''
			},
			//获取活动详情
			async getDetailData() {
				let param = {
					id: this.vacationId
				}
				ajaxParam(param)
				const res = await post('admin/vacation/detail', qs.stringify(param))
				
				this.vacationName +=res.data.entity.vacationName
			},
			//获取热力学校榜
			async getHotSchoolList(){
				let param = {
					startCompanyId: localStorage.getItem('companyId'),
					vacationId: this.vacationId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/index/hotSchoolList', qs.stringify(param))
				if (res.data.code == 200) {
					this.hotSchoolList = res.data.page.items
					this.total = res.data.page.count
				}
			},
			//分页
			handleCurrentChange(e){
				this.hotSchoolList = []
				this.pageNum = e.number
				this.getHotSchoolList()
			},
			handleCurrentChange2(e){
				this.tableData = []
				this.pageNum2 = e.number
				this.getHotStudentList(this.schoolId,this.school)
			},
			showSchoolDialog(row){
				this.dialogTable = true
				this.schoolId = row.schoolId
				this.school = row.school
				this.getHotStudentList(row.schoolId,row.school)
			},
			//获取学生榜
			async getHotStudentList(id,school){
				let param = {
					startCompanyId: localStorage.getItem('companyId')||'',
					vacationId: this.vacationId,
					schoolId: id,
          school: school,
					memberId: localStorage.getItem('userId')||'',
					pageNum: this.pageNum2,
					pageSize: this.pageSize2
				}
				ajaxParam(param)
				const res = await post('admin/index/hotStudentList', qs.stringify(param))
				if (res.data.code == 200) {
					this.tableData = res.data.page.items
					this.studentTotal = res.data.page.count
				}
			},
			//收藏大学生
			async addCollectStu(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/save', qs.stringify(param))
				if (res.data.code == 200) {
					//收藏成功
					this.$message.success('收藏成功！')
					this.tableData.forEach(item=>{
						if(item.id==id) {
							item.isLike = '1'
						}
					})
				}
			},
			//取消收藏大学生
			async cancelCollectStu(id){
				let param = {
					memberId: localStorage.getItem('userId')||'', //当前登录用户id
					likeId: id  //收藏的大学生id
				}
				ajaxParam(param)
				const res = await post('admin/memberLike/delete', qs.stringify(param))
				if (res.data.code == 200) {
					//取消收藏成功
					this.$message.success('取消收藏成功！')
					this.tableData.forEach(item=>{
						if(item.id==id) {
							item.isLike = '0'
						}
					})
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}
	.dialog-table{
		width: 100%;
		font-size: 12px;
		th{
			width: 130px;
			background: #F3F4F6;
		}
		th,td{
			padding: 8px 20px;
			border: 1px solid #DBDCDC
		}
		td .certificate{
			width: 130px;
		}
	}
	.collect-icon{
		display: block;
		width: 16px;
		height: 16px;
		margin-left: 10px;
	}
	.text-link{
		color: #2A76CD;
		font-size: 12px;
		cursor: pointer;
	}
</style>
